export const SIZE_136_136 = 'Size136x136Crop';
export const FUNDRAISING_PAGE_HERO_IMAGE_M = 'FundraisingPageHeroImageM';
export const LOGO = 'Size120x120';
